// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import BtnAudio from "../core/prefabs/BtnAudio";
import UIPositionContainer from "../core/components/UIPositionContainer";
import BtnPlay from "../core/prefabs/BtnPlay";
import FitTextToBounds from "../core/components/FitTextToBounds";
import LocaliseText from "../core/components/LocaliseText";
/* START-USER-IMPORTS */
import assetPack from '../../../static/assets/asset-pack-title.json';
import assetPackIntro from '../../../static/assets/asset-pack-intro.json';
import { app } from '../core/App';
import UIButton from '../core/components/UIButton';
import { TransitionPoint } from '../rooting';
/* END-USER-IMPORTS */

export default class Title extends BaseScene {

  constructor() {
    super("Title");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg
    const bg = this.add.image(960, 384, "title", "bg-title.jpg");
    bg.scaleX = 1.1;
    bg.scaleY = 1.1;

    // title
    const title = this.add.image(960, 141, "title", "logo.png");

    // btnAudio
    const btnAudio = new BtnAudio(this, 1845, 74.5);
    this.add.existing(btnAudio);

    // btnPlay
    const btnPlay = new BtnPlay(this, 960, 480);
    this.add.existing(btnPlay);

    // subtitle
    const subtitle = this.add.text(960, 320, "", { rtl: true });
    subtitle.setOrigin(0.5, 0.5);
    subtitle.text = "Treasure Rush";
    subtitle.setStyle({ "align": "center", "fontFamily": "ARCO", "fontSize": "100px" });

    // bears
    const bears = this.add.image(924, 645, "title", "bears.png");

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    // subtitle (components)
    const subtitleFitTextToBounds = new FitTextToBounds(subtitle);
    subtitleFitTextToBounds.MaxWidth = 980;
    const subtitleLocaliseText = new LocaliseText(subtitle);
    subtitleLocaliseText.copyId = "treasureRush";

    this.bg = bg;
    this.title = title;
    this.btnAudio = btnAudio;
    this.btnPlay = btnPlay;
    this.subtitle = subtitle;
    this.bears = bears;

    this.events.emit("scene-awake");
  }

  private bg!: Phaser.GameObjects.Image;
  private title!: Phaser.GameObjects.Image;
  private btnAudio!: BtnAudio;
  private btnPlay!: BtnPlay;
  private subtitle!: Phaser.GameObjects.Text;
  private bears!: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  private bearPosY: number = 0;

  public preload() {
    console.log(this.cache);
    console.log(this.textures);

    this.load.pack('asset-pack-title', assetPack as any);
    this.load.pack('asset-pack-intro', assetPackIntro as any);

    this.load.once(Phaser.Loader.Events.COMPLETE, this.postload, this);
  }

  public postload() {
    super.postload();

    console.log(this.cache);
    console.log(this.textures);
    // app.unload(this, assetPack);
  }

  public create() {
    this.load.off(Phaser.Loader.Events.COMPLETE, this.postload, this);
    this.editorCreate();

    this.bearPosY = this.bears.y;

    //this.btnAudio.setButtonState(!this.getAudioIsMuted());
    //this.btnAudio.on(Phaser.Input.Events.POINTER_UP, this.toggleAudio, this);

    this.btnPlay.on(UIButton.events.clicked, () => {
      let hasSeenIntro = false;
      app.gotoNextScene(this, hasSeenIntro ? TransitionPoint.TitleEnd2 : TransitionPoint.TitleEnd1, { test: 'test' });
    });

    this.transitionInInit();
    //this.time.addEvent({ delay: 100, callback: this.transitionIn, callbackScope: this });
    this.transitionIn();
    // this.transitionOn();

    app.audioHandler.playSound(this, 'SndMusicLoop', 'music', {
      volume: 0.2,
      loop: true
    });
  }

  protected transitionInInit() {
    this.title.scale = 0.4;
    this.subtitle.scale = 0.25;
    this.btnPlay.y = 900;
    this.bears.y = this.bears.y +200;
    this.bears.scale = 1.1;
  }

  protected transitionIn() {

    this.add.tween({
      targets: this.bg,
      scaleX: 1,
      scaleY: 1,
      duration: 1000,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.bears,
      scaleX: 1,
      scaleY: 1,
      y: this.bearPosY,
      duration: 1200,
      delay: 0,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.title,
      scaleX: 1,
      scaleY: 1,
      duration: 1000,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.subtitle,
      scaleX: 1,
      scaleY: 1,
      duration: 1250,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.btnPlay,
      y: 480,
      duration: 750,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.time.addEvent({ delay: 1500, callback: this.startIdles, callbackScope: this });
  }

  protected startIdles() {
    this.add.tween({
      targets: this.subtitle,
      scaleX: 1.025,
      scaleY: 1.025,
      duration: 2000,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });

    this.add.tween({
      targets: this.bears,
      scaleX: 1.005,
      scaleY: 1.005,
      duration: 3000,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });
  }
/*
  protected getAudioIsMuted(): boolean {
    return app.audioHandler.getChannelMute('music');
  }

  protected toggleAudio() {
    let isMuted = this.getAudioIsMuted();
    app.audioHandler.setChannelMute('sfx', !isMuted);
    app.audioHandler.setChannelMute('music', !isMuted);
  }
*/
  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
